import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { ROLES } from '../lib/permissions';

const NAV_ITEMS = [
  {
    id: 'hoy',
    path: '/',
    label: 'Hoy',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="4" width="18" height="18" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" />
      </svg>
    ),
  },
  {
    id: 'sesiones',
    path: '/sesiones',
    label: 'Sesiones',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <rect x="3" y="3" width="18" height="18" rx="2" />
        <path d="M3 9h18M9 3v18" />
        <path d="M13 13h4M13 17h4" />
      </svg>
    ),
  },
  {
    id: 'buscar',
    path: '/buscar',
    label: 'Animales',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="11" cy="11" r="8" /><path d="m21 21-4.35-4.35" />
      </svg>
    ),
  },
  {
    id: 'datos',
    path: '/datos',
    label: 'Datos',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M18 20V10M12 20V4M6 20v-6" />
      </svg>
    ),
  },
  {
    id: 'perfil',
    path: '/perfil',
    label: 'Ajustes',
    icon: (
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" />
      </svg>
    ),
  },
];

export function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const role = useAuthStore((s) => s.role);
  const config = ROLES[role];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <div
      className={`hidden lg:flex flex-col bg-[var(--bg-primary)] border-r border-[var(--border-default)] h-full transition-all duration-200 ${collapsed ? 'w-16' : 'w-[220px]'}`}
    >
      <nav className="flex flex-col gap-1 p-2 flex-1">
        {NAV_ITEMS.map((item) => {
          const active = isActive(item.path);
          const label = item.id === 'hoy' ? config.hoyLabel : item.label;
          return (
            <button
              key={item.id}
              onClick={() => navigate(item.path)}
              className={`flex items-center gap-3 px-3 py-2.5 rounded-lg border-none cursor-pointer transition-colors duration-150 ${active ? 'bg-[rgba(26,107,181,0.1)] text-[var(--status-info)]' : 'bg-transparent text-[var(--text-tertiary)] hover:bg-[var(--bg-secondary)]'}`}
            >
              {item.icon}
              {!collapsed && (
                <span className="text-sm font-semibold">{label}</span>
              )}
            </button>
          );
        })}
      </nav>

      <div className="p-3 border-t border-[var(--border-default)]">
        <div className="flex items-center gap-2.5">
          <div
            className="w-9 h-9 rounded-full flex items-center justify-center text-white text-sm font-bold flex-shrink-0"
            style={{ background: config.color }}
          >
            {config.letter}
          </div>
          {!collapsed && (
            <div className="overflow-hidden">
              <div className="text-sm font-semibold text-[var(--text-primary)] truncate">
                {config.name}
              </div>
              <div className="text-[11px] text-[var(--text-tertiary)] truncate">
                {config.role}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
